import * as ApiManager from '../_manager';
import store from '@/store';

export const adminScreener = {
  list: payload => {
    return ApiManager.callApi (`/admin/screener/list`, payload);
  },
  listVodEvents: payload => {
    return ApiManager.callApi (`/admin/screener/listVodEvents`, payload);
  },
  listVodEventByIds: payload => {
    return ApiManager.callApi (`/admin/screener/listVodEventByIds`, payload);
  },
};
